import Vue from "vue";
import { getHotComments } from '../../../request/request'
import localstorageUtil from "@/_utils/localstorageUtil";
import { lazyLoadBlocks } from '@/pages/article_main/js/lazyLoadBlock'
import RightSideBar from '../../../vuecomps/rightSideBar/Index.vue' // 右侧边栏
import ArticleLike from '../../../vuecomps/articleLike.vue' // 文末点赞
import NumberFix from '../../../utils/number-text'
import  {jsonp} from '../../../request/jsonp'
import FloatBtn from '../../../vuecomps/floatBtn.vue'
import Share from '../../../vuecomps/share.vue'
import report from '../../../vuecomps/report.vue'
import BannedNotice from '../../../vuecomps/comment/banned-notice.vue'
import AllSeeList from '../../../vuecomps/allSeeList.vue'
import MeComment from '../../../vuecomps/comment/MeComment.vue'
import { importLogin } from '@/utils/login'
import HeadRight from '@/vuecomps/headRight.vue'
import MoreNav from '@/vuecomps/moreNav.vue'
import { getCookie } from "mpfe-utils"
import Utils from "@/utils/Utils"
import ShareInteraction from '../../../vuecomps/shareInteraction/index.vue'
import { CommentStore } from '@/store/index'

// 推荐阅读
const renderRecommendFeed = function() {
    if(!document.querySelector('#groomRead')) return
    import(/* webpackChunkName: "article_recommend" */'../../../vuecomps/groomRead.vue')
    .then((res)=>{
        const comp = res.default
        new Vue({
            el: "#groomRead",
            components: {
                GroomRead: comp
            }
        })
    }).catch((e)=>{
        console.log('渲染失败，推荐阅读',e)
    })
}

// 右边栏 文章等级为A、S-
const renderRightSideBar = function() {
    if(document.querySelector("#right-side-bar")) {
        new Vue({
            el: "#right-side-bar",
            components: {
                RightSideBar
            }
        })
    }
}

// 加载"我来说两句"
const renderMeComment = ()=>{
    new Vue({
        el: "#meComment",
        components: {
            MeComment
        },
    })
}
// 获取左侧评论数+滚动到评论区块
const handleComment = function() {
    const countDom = document.querySelector('.share-interaction-c .comment-count')
    if(!countDom) return
    const pcArticleInfo = window?.pcArticleInfo || {}
    const params = {
        page_size: 1,
        topic_source_id: `mp_${pcArticleInfo?.news_id}`,
        page_no: 1,
        hot_size: 1,
        media_id: pcArticleInfo?.media_id,
        topic_category_id: pcArticleInfo?.channel_id,
        topic_url: window.location.href,
        source_id: `mp_${pcArticleInfo?.news_id}`,
        accountId: pcArticleInfo?.media_id
    }

    getHotComments(params).then((res)=>{
        if(res.code === 1) {
            CommentStore.setShowFirstComment(!res?.data?.hasFirstComment)
            const participationSum = res?.data?.participationSum || 0
            const count = res?.data?.outerCmtSum
            countDom.innerHTML = count ? count > 999 ? '999+' : count : '评论'
            const meCommentData = {
                outerCmtSum: res?.data?.outerCmtSum || 0,
                participationSum: participationSum,
                topicId: res.data?.topicId,
            }
            window.EVENT_BUS.$emit('meCommentData',meCommentData)
        }
    })
    // 存在缓存评论直接加载评论区块
    const unpublishedComment = localstorageUtil.getItem('unpublishedComment')
    if(unpublishedComment)renderCommentList()
}
// 评论列表
const renderCommentList = ()=>{
    if(!document.querySelector('#commentList')) return
    import(/* webpackChunkName: "article_comment_list" */'../../../vuecomps/comment/CommentList.vue')
    .then((res)=>{
        if(res && res.default) {
            const comp = res.default
            new Vue({
                el: "#commentList",
                components: {
                    CommentList: comp
                },
            })
        }
    }).catch((e)=>{
        console.log('渲染失败，评论',e)
    })
}

// 懒加载区块
const lazyLoadBLock = function(blockIds=[]) {
    const blockMap = {
        groomRead: { key: '#groomRead', callback: renderRecommendFeed }, // 推荐阅读
        commentList: { key: '#commentList', callback: renderCommentList }, // 评论列表
    }
    const blocks = []
    blockIds.forEach((id)=>{
        blocks.push(blockMap[id])
    })
    lazyLoadBlocks(blocks,1000)
}

// 左侧作者卡片
const renderUserProfile = function() {
    // 文章数
    let numEl= document.querySelector(".user-num [data-role='info-article-num']")
    let numData = numEl && numEl.getAttribute("data-value") || 0
    numData = numData ? new NumberFix(numData).format() : 0
    let infoArticleNum = document.querySelector(".user-num [data-role='info-article-num'] .num")
    if(infoArticleNum)infoArticleNum.innerHTML = numData
    // 阅读数
    const mediaId = window.pcArticleInfo?.media_id
    let count = 0
    jsonp(`//v2.sohu.com/public-api/authors/pv`,{authorIds:mediaId}).then((data)=>{
        if(data) {
            count = data[mediaId] || 0
        }
      }).finally(()=>{
        let dom = document.querySelector(".user-num [data-role='info-read-num'] .num")
        if(dom)dom.innerHTML = count ? new NumberFix(count).format() : 0
      })
    //   hover发送埋点
    const integrationDom = document.getElementById('fox-integration')
    integrationDom && integrationDom.addEventListener('mouseenter',()=>{
        window?.sohuSpm?.sendAction({ acode: 8408 });
    })
}

// 右侧悬浮按钮
const renderRightBtns = function() {
    if(!document.querySelector('#float-btn')) return
            new Vue({
                el: "#float-btn",
                components: {
                    floatBtn: FloatBtn
                },
            })
}
// 左侧分享
const renderLeftShare = function() {
    if(!document.querySelector('#share')) return
    new Vue({
        el: "#share",
        components: {
            share: Share
        },
    })
}


// 处理“展开更多”
const handleShowMore = function() {
    const showMoreDom = document.querySelector('#showMore')
    if(showMoreDom) {
        showMoreDom.addEventListener('click', function (e) {
            window.EVENT_BUS.$emit('lookAll')
            e?.preventDefault();
            const hideEl = document.querySelector('.hidden-content')
            if(hideEl)hideEl?.classList?.remove('control-hide');
            const lookallBox = document.querySelector('.lookall-box')
            lookallBox?.classList?.add('control-hide');
            window?.sohuSpm?.sendAction({
                acode: 8434
            });
        })
    }
}
// 正文插入功能卡&推荐卡
const renderArticleInsert = function() {
    const mpPluginList = document.querySelectorAll('#mp-editor mp-plugin')
    if(mpPluginList?.length) {
        import(/* webpackChunkName: "article-insert" */'../../../vuecomps/article-insert/index.js').then((res) => {
            res?.renderArticleInsert()
        }).catch((err) => {
            console.log(err, '功能卡失败')
        })
    }
}

// 大家都在看
const renderAllSeeList = function() {
    new Vue({
        el: "#articleAllsee",
        components: {
            allSeeList: AllSeeList
        },
    })
}
// 内容举报
const renderArticleReport = ()=> {
    if(!document.querySelector("#articleReport"))return
    new Vue({
        el: "#articleReport",
        components: {
            report,
        },
    })
}

//请求转载文章信息 有originalId才发送请求
const renderReprint = ()=>{
    const pcArticleInfo = window?.pcArticleInfo
    var isPort = pcArticleInfo?.originalStatus == 2 && pcArticleInfo?.originalId && pcArticleInfo?.originalId != 'null';
    if (isPort) {
        import(/* webpackChunkName: "article_transfer" */'../../../vuecomps/articleReprint.vue')
        .then((res)=>{
            if(res && res.default) {
                const comp = res.default
                new Vue({
                    el: "#articleTransfer",
                    components: {
                        transfer: comp
                    },
                })
            }
        }).catch((e)=>{
            console.log('渲染失败，请求转载文章信息',e)
        })
    }
}

// 文章阅读数
const renderArticlePv = ()=>{
    const articleId = window?.pcArticleInfo?.news_id
    let count = 0
    jsonp(`//v2.sohu.com/public-api/articles/${articleId}/pv`).then((data)=>{
        count = data || 0
    }).finally(()=>{
        const pvDom = document.querySelector("[data-role='pv']")
        if(pvDom)pvDom.innerHTML = new NumberFix(count).format()
    })
}

// 禁言封禁通知
const showBannedNotice = ()=>{
    if(!document.querySelector('#bannedNotice')) return
    new Vue({
        el: '#bannedNotice',
        components: {
            BannedNotice: BannedNotice
        }
    });
}
// 渲染登录组件
const renderLogin = () => {
    // 已登录
    if(window?.userInfo?.userId) {
        importLogin().then((res)=>{
            const LoginBtn = res.loginBtnIndex
            new LoginBtn({
                el: "#head-login",
                mark: "article",
                type: "other"
            });
        })
    }
}


// 积分勋章
const renderMedal = () => {
    const medal = document.querySelector('#fox-integration')
    if(medal) {
        import(/* webpackChunkName: "article_medal" */'../../../vuecomps/medal.vue').then((res)=>{
            const Medal = res.default
            new Vue({
                el: '#fox-integration',
                components: {
                    Medal
                }
            });
        }).catch((err)=>{
            console.log(err,'积分勋章失败')
        })
    }
}
// 导航右侧
const renderHeadRight = ()=>{
    if(document.querySelector('#headRight')) {
        new Vue({
            el: '#headRight',
            components: {
                HeadRight
            }
        })
    }
}

const renderMoreNav = ()=>{
    if(document.querySelector('#moreNav')) {
        new Vue({
            el: '#moreNav',
            components: {
                MoreNav
            }
        })
    }
}

// 按需引入sentry，减轻sentry服务压力
const asyncImportSentry = () => {
    const isImportSentry = Utils.isImportSentry()
    if(isImportSentry) {
        import(/* webpackChunkName: "dynamic4sentry" */'@sentry/vue')
       .then((sentry)=>{
            sentry.init({
                Vue,
                dsn: 'https://77b484273ff681780479e0f122a14218@sentry.mp.sohu.com/47',
                attachStacktrace: true,
                integrations: [
                    sentry.browserTracingIntegration(),
                ],
                release: RELEASEVERSION,
                tracesSampleRate: 0.05, // 性能上报采样率
                sampleRate: 0.05, // 错误采样率
            })
            sentry.setTag("SUV", getCookie('SUV'))
        }).catch((e)=>{
            console.log('sentry...',e)
        })
    }
}

// 处理特殊权益-当前为登录可见权益的功能
const renderSpecialBenefits = async (opts) => {
    console.log('此时', opts)
    const { displayMode, stage, isFocus } = opts
    console.log('处理特殊权益',displayMode, typeof displayMode, stage)
    if (displayMode == '0' || displayMode == '1') return
    // 命中权益的文章
    window?.sohuSpm?.sendAction({
        acode: 11064,
        clkParam: `displayMode:${displayMode};articleId:${opts?.news_id || opts?.newsId};`
    });
    try {
        const { handleSpecialBenefits } = await import(/* webpackChunkName: "benefits_chunk" */'./handleBenefits');
        handleSpecialBenefits(displayMode, stage, isFocus)
    } catch (error) {
        console.error('加载 handleSpecialBenefits 模块失败:', error);
    }
}

const renderHeadVideo = (opts)=>{
    const headVideo = document.querySelector('#head-video')
    const articleElement = document.querySelector('.article')
    const initShowMode = opts.displayMode === '0' || opts.displayMode === '1'
    if (headVideo && articleElement && initShowMode) {
        initHeadVideo(opts)
    }
}

const initHeadVideo = opts => {
    const headVideo = document.querySelector('#head-video')
    const HVTitle = opts.HVTitle
    const contentHTML = `
        <div id="sohuplayer"></div>
        <p class="video-title">
            <span class="video-ionc"></span>
            ${HVTitle}
        </p>
    `
    headVideo.insertAdjacentHTML('afterbegin', contentHTML)
    // 调用搜狐视频sdk渲染
    const videoId = opts.videoId
    const site = opts.site
    const playerParams = {
        el: '#sohuplayer',
        autoplay: false,
        width: '500',
        height: '300',
        mute: 1,
        disablePlaylist: true, // h5播放器禁用下一集按钮
        variables: [
            ['showRecommend', '0'], // 0时不展示后推荐；默认展示
        ],
    }
    site == '1' ? (playerParams.vid = videoId) : (playerParams.bid = videoId)
    console.log('调用搜狐视频sdk渲染', playerParams)
    showPlayer(playerParams)
}
// 初始化中插视频
window.MiddleInsertVideoOnPlay0 = function (e) {
    console.log('中插视频播放')
    sendAction({
        acode: 11134,
        clkParam: 'scene:pccontent;'
    })
}
const renderMiddleInsertVideo = () => {
    document.querySelectorAll('#mp-editor div.place_video').forEach(function (el, idx) {
        let vid = el.getAttribute('data-vid') || '';
        let bid = el.getAttribute('data-bid') || '';
        let id = el.getAttribute('id');
        // return
        if (vid || bid) {
            showPlayer({
                el: '#' + id,
                vid: vid,
                bid: bid,
                autoplay: false,
                disablePlaylist: true,
                appid: 'tv',
                mute: 0,
                variables: [
                    ['onPlay', 'MiddleInsertVideoOnPlay'+idx],
                ]
            })
        }
        window['MiddleInsertVideoOnPlay' + idx] = () => {
            window?.sohuSpm?.sendAction({
                acode: 11134,
                clkParam: `scene:pccontent;vid:${vid};bid:${bid};`,
            })
        }

    });

}
// 左侧：互动+分享
const renderShareInteration = ()=>{
    if(document.querySelector('#shareInteraction')) {
        new Vue({
            el: '#shareInteraction',
            components: {
                ShareInteraction
            }
        })
    }
}

export {
    renderRecommendFeed,
    handleComment,
    lazyLoadBLock,
    renderRightSideBar, // 右边栏
    renderUserProfile,
    renderRightBtns,
    renderLeftShare,
    handleShowMore,
    renderArticleInsert,
    renderAllSeeList,
    renderArticleReport,
    renderReprint,
    renderArticlePv,
    showBannedNotice,
    renderMeComment,
    renderLogin,
    renderMedal,
    renderHeadRight,
    renderMoreNav,
    asyncImportSentry,
    renderSpecialBenefits,
    renderHeadVideo,
    renderMiddleInsertVideo,
    initHeadVideo,
    renderShareInteration
}